import { alpha, Box, Grid, Typography } from '@mui/material'
import React from 'react'
import { AppRetailerBlock } from '@components'
import { AccordionSeeker } from '@ui-seeker/core'
import { useSignal } from '@preact/signals-react'
import ErrorDataPopover from 'Pages/RealTimeHistory/RealTime/ErrorData/Popover'
import { useErrorPopover } from 'Pages/RealTimeHistory/RealTime/@hooks'

export default function RealTimeTableErrorsDataTemplate({ data, title, color }) {
	const isOpen = useSignal(false)
	const { onOpenPopover, isOpenPopover, onClosePopover } = useErrorPopover()

	return <Grid container sx={{
		p: 1,
		borderBottom: "2px solid",
		borderColor: "primary.main",
		mb: .5
	}}>
		<Grid item xs={12}>
			<AccordionSeeker
				title={title}
				expanded={isOpen.value}
				onChange={() => isOpen.value = !isOpen.value}
			>
				{Object.keys(data).map((date, idx) => (
					<Box key={`${date}-${idx}`}>
						<Typography variant="body1" sx={{ ml: 1, }}>
							{date}
						</Typography>
						<Box sx={{
							display: "flex",
							alignItems: "center",
							justifyContent: "start",
							flexWrap: "wrap",
							ml: 2,
						}}>
							{data[date].map(({ siteIco, siteCountry, siteName, info }) => {
								return <Box
									onClick={e => onOpenPopover(e.currentTarget, info)}
									key={siteIco}
									sx={{
										display: "flex",
										alignItems: "center",
										justifyContent: "center",
										m: .25,
										backgroundColor: alpha(color, 0.2),
										borderRadius: "5px",
										p: .75,
										minWidth: "130px",
										cursor: "pointer",
										"&:hover": {
											backgroundColor: alpha(color, 0.4),
										}
									}}>
									<AppRetailerBlock retailer={siteName} country={siteCountry} icon={siteIco}/>
								</Box>
							})}
						</Box>
					</Box>
				))}
				<ErrorDataPopover isOpen={isOpenPopover} onClose={onClosePopover}/>
			</AccordionSeeker>
		</Grid>
	</Grid>
}